import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListMoteComponent } from './list-mote.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { OfflineModule } from '../../offline'

@NgModule({
    declarations: [ListMoteComponent],
    imports: [
        CommonModule, SvgIconModule, MotePipesModule, OfflineModule
    ],
    exports: [ListMoteComponent]
})
export class ListMoteComponentModule { }
